<template>
  <Breadcrumbs
      title="Edit Dealer"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Dealers', path: '/dealers' },
      { label: 'Edit Dealer', path: '/edit-dealer' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editDealerForm/>
    </div>
  </div>
</template>

<script>

import editDealerForm from "@/pages/master_data/dealers/editDealerForm.vue";

export default {
  components: {
    editDealerForm
  }
}
</script>